import { ScaleElement } from '@scale/base-element';

class ScaleProductRecommendations extends ScaleElement {
  #loaded = false;
  #observer;

  setup() {
    if (this.querySelector('.product-recommendations__grid, .product-recommendations__slider')) {
      this.#loaded = true;
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !this.#loaded) {
          this.#observer.disconnect();
          this.#loadRecommendations();
        }
      },
      { rootMargin: '200px' }
    );

    this.#observer.observe(this);
  }

  teardown() {
    this.#observer?.disconnect();
  }

  async #loadRecommendations() {
    const url = this.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const recommendations = doc.querySelector('scale-product-recommendations');

      if (recommendations?.innerHTML.trim()) {
        this.innerHTML = recommendations.innerHTML;
        this.#loaded = true;
      }
    } catch {
      // Network errors are expected (offline, navigation away)
    }
  }
}

if (!customElements.get('scale-product-recommendations')) {
  customElements.define('scale-product-recommendations', ScaleProductRecommendations);
}
